module.exports = __webpack_public_path__ + "img/0x52f04C806EB82930F40D410259b7AF8E18d3BDc9.ae80caf6.png";